import React, { useState } from 'react';
import useAllPosts from '../hooks/usePostsListener';
import { useAuth } from '../contexts/AuthContext';
import Posts from './Profiles/Posts';
import { Link, useHistory } from 'react-router-dom';
import { createPost, createComment } from './FirebaseFunctions';
import Create from './Create';
import '../styles/Feed.css';

function FeedRailLinks() {
  return (
    <ul className="feed-rail-nav">
      <li>
        <Link to="/events">Events</Link>
      </li>
      <li>
        <Link to="#">Network (coming soon)</Link>
      </li>
      <li>
        <Link to="#">Groups (coming soon)</Link>
      </li>
      <li>
        <Link to="#">Marketplace (coming soon)</Link>
      </li>
    </ul>
  );
}

const Feed = () => {
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [updated, setUpdated] = useState(false);
  const [loading, setLoading] = useState(true);
  const { allPosts } = useAllPosts(updated);
  const history = useHistory();
  const { currentUser } = useAuth();

  function handleChange() {
    if (loading !== false) setLoading(false);
  }

  const handleSubmit = (type, id) => async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setLoading(true);
    try {
      if (type === 'post') {
        await createPost(
          currentUser.uid,
          e.target[0].value,
          e.target[1].value,
          e.target[2].files[0]
        );
      } else {
        await createComment(currentUser.uid, e.target[0].value, id);
      }
      setSuccess('Successfully updated');
      setUpdated(!updated);
      document.getElementById('create').reset();
    } catch (err) {
      console.log(err);
      setError('Failed to update account');
    } finally {
      setLoading(false);
    }
  };

  if (!currentUser) {
    history.push('/login');
    return null;
  }

  return (
    <div className="feed-page">
      <div className="feed-layout">
        <main className="feed-main">
          <h1 className="feed-title">For You</h1>

          <div className="feed-rail-mobile">
            <FeedRailLinks />
            <p className="feed-sponsored">Sponsored</p>
          </div>

          <Create />
          <div className="posts">
            <Posts
              posts={allPosts}
              handleSubmit={handleSubmit}
              handleChange={handleChange}
            />
          </div>
        </main>

        <aside className="feed-rail d-none d-md-block">
          <FeedRailLinks />
          <p className="feed-sponsored">Sponsored</p>
        </aside>
      </div>
    </div>
  );
};

export default Feed;
